module.exports = __webpack_public_path__ + "img/a8.5d4efa77.svg";